import React ,{useEffect}from "react";
import '../Css/Blog.css';


function Blog()
{
    useEffect((()=>
  {
    document.title ='Blog';
  }))
    return(
        <div id="blogmain">
        <h1>blog</h1>
        </div>
    )
}
export default Blog;